import { Button, colors, Spinner, Tooltip } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useDownloadIMQsPageStore } from 'store/pages/download-imqs/pageStore';
import { Download, DriveFile } from '@insurancemenu/imenu-components-lib/dist/icons';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import SendOutEmailsModal from 'components/common/modals/SendOutEmailsModal';
import { FileButtonStyled, FileNameSectionStyled, PageFooterStyled, WrapperStyled } from './styles';
import { SEND_OUT_IMQS_FORM_ID } from '../constants';

export const DownloadIMQsPageContent: React.FC = observer(() => {
  const { imqsZipName, isLoading, downloadZip, getIMQsZip, sendOutEmailsModalStore } = useDownloadIMQsPageStore();

  useEffect(() => {
    void getIMQsZip();
  }, []);

  return (
    <>
      <WrapperStyled>
        {isLoading ? (
          <Spinner size="2.6rem" />
        ) : (
          <>
            <FileNameSectionStyled>
              <FileButtonStyled
                type="text"
                color="primary"
                leftIconProp={<DriveFile width="2rem" height="2rem" color={colors.blue[600]} />}
                onClick={downloadZip}
              >
                {imqsZipName}
              </FileButtonStyled>
            </FileNameSectionStyled>
            <Tooltip alignment={AlignmentTypes.LEFT_CENTER} label="Download zip">
              <Button type="icon" color="primary" onClick={downloadZip}>
                <Download width="2.4rem" />
              </Button>
            </Tooltip>
          </>
        )}
      </WrapperStyled>
      <PageFooterStyled>
        <Button size="large" type="outlined" color="primary" onClick={sendOutEmailsModalStore.open}>
          Send out IMQs
        </Button>
      </PageFooterStyled>
      <SendOutEmailsModal
        title="Send out IMQs"
        subtitle="Send out IMQs to the selected recipients"
        modalStore={sendOutEmailsModalStore}
        formId={SEND_OUT_IMQS_FORM_ID}
      />
    </>
  );
});
